var render, staticRenderFns
import script from "./ScrollControls.vue?vue&type=script&lang=js&"
export * from "./ScrollControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ce0441')) {
      api.createRecord('11ce0441', component.options)
    } else {
      api.reload('11ce0441', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/scripts/components/ScrollControls.vue"
export default component.exports